import React from 'react'
import jwtDecode from 'jwt-decode'
import * as Sentry from "@sentry/react"
import { Integrations } from '@sentry/tracing'
import { ExtraErrorData } from "@sentry/integrations";

import Providers from 'layouts/Providers'
import { GlobalStyle } from 'styles/global'

import 'styles/fonts.css'

export function onClientEntry() {
  window.dataObject = {
    page: window.location.pathname,
    url: window.location.href,
    cartProduct: [],
    handProduct: [],
    time: Date(),
    event: window.location.pathname.match(/(checkout|order-confirmation)/g)
      ? []
      : [
          {
            name: 'screenLoad',
            page: window.location.pathname,
            url: window.location.href,
            time: Date()
          }
        ],
    user: {
      userID: localStorage.token ? jwtDecode(localStorage.token).id : null,
      verifiedEmail: localStorage.user ? JSON.parse(localStorage.user).emailVerified : null
    }
  }

  Sentry.init({
    dsn: process.env.GATSBY_SENTRY_DSN,
    environment: process.env.GATSBY_SENTRY_ENVIRONMENT,
    release: process.env.GATSBY_SENTRY_RELEASE,
    integrations: [
      new Integrations.BrowserTracing(),
      new ExtraErrorData()
    ],
    tracesSampleRate: 0.5
  })
}

const beforeSentryCapture = scope => {
  if (localStorage.user) {
    try {
      if (localStorage.user && localStorage.user !== '') {
        const user = JSON.parse(localStorage.user)
        scope.setUser({
          id: user.id,
          email: user.email
        })
      }
    } catch (e) {}
  }
}

export const wrapRootElement = ({ element, ...props }, ...args) => (
  <Sentry.ErrorBoundary fallback={'An error has occurred'} beforeCapture={beforeSentryCapture}>
    <Providers {...props} {...args}>
      {element}
    </Providers>
  </Sentry.ErrorBoundary>
)

export const wrapPageElement = ({ element }) => (
  <>
    <GlobalStyle />
    {element}
  </>
)